
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-core-v5-migration-update",
      function () {
        return require("private-next-pages/blog/mui-core-v5-migration-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-core-v5-migration-update"])
      });
    }
  